export default __webpack_public_path__ + "static/media/0000..0006.ff4a7a8b.png";